const BackButton = ({
    handleBack
}) => {
    return (
        <>
            <span onClick={handleBack} className="cursor-pointer">
                <i className='fa fa-chevron-left' />
                {" "}Back
            </span>
        </>
    )
}

export default BackButton